import { ApiClient } from '@/auth/api';
import { createContext, useContext, useState } from 'react';
import { useAuth } from './useAuth';

export interface ApiContextValue {
  apiClient: ApiClient;
}

const ApiContext = createContext<ApiContextValue | undefined>(undefined);

export function useApiClient() {
  const context = useContext(ApiContext);
  if (!context) {
    throw new Error('useApiClient must be used within an ApiProvider');
  }
  return context;
}

export function ApiProvider({ children }: { children: React.ReactNode }) {
  const { useSession } = useAuth();
  const { data: session } = useSession();
  const [apiClient] = useState(new ApiClient(session?.session.token || null));

  return (
    <ApiContext.Provider
      value={{
        apiClient,
      }}
    >
      {children}
    </ApiContext.Provider>
  );
}
